import React, { useContext, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../../App';

const translations = {
  en: {
    readMore: 'Read Full Story →',
    imagePlaceholder: 'Story Image'
  },
  hi: {
    readMore: 'पूरी कहानी पढ़ें →',
    imagePlaceholder: 'कहानी की तस्वीर'
  }
};

interface StoryCardProps {
  id: string;
  name: string;
  story: string;
  image: string;
  category: string;
  delay?: number;
}

const StoryCard: React.FC<StoryCardProps> = ({ id, name, story, image, category, delay = 0 }) => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const getDefaultBackground = () => {
    const colors = ['from-primary/10 to-secondary/10', 'from-secondary/10 to-primary/10'];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    return `bg-gradient-to-r ${randomColor}`;
  };

  return (
    <motion.div
      className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay }}
    >
      <div className={`relative h-48 ${imageError ? getDefaultBackground() : ''}`}>
        {!imageError && image ? (
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover"
            onError={handleImageError}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <div className="text-primary/50">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
        )}
        <div className="absolute top-4 right-4 bg-primary text-white px-3 py-1 rounded-full text-sm font-hindi">
          {category}
        </div>
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-baloo font-bold text-gray-800 mb-3">
          {name}
        </h3>
        <p className="text-gray-600 font-hindi line-clamp-3">
          {story}
        </p>
        <Link 
          to={`/stories/${id}`}
          className="mt-4 inline-block text-primary font-hindi hover:text-primary/80 transition-colors"
        >
          {t.readMore}
        </Link>
      </div>
    </motion.div>
  );
};

export default StoryCard; 